import React, { FC, useEffect, useState } from 'react'
import { CurrentUserType } from 'src/ducks/auth'
import GameModal from '../../components/Gamification/GameModal'
import LoadIcon from '../../components/LoadIcon'
import { LobbyEntry } from '../../components/LobbyEntry'
import PageWithBg from '../../components/PageWithBg'
import config from '../../config'
import Amplitude from '../../utils/amplitudeHelper'
import GameStand from '../../images/gamification/gameStand.gif'
import { StyledLobby } from './styled'

export const LobbyPage: FC<{ currentUser: CurrentUserType }> = ({ currentUser }) => {
  const [showLobbyModal, setShowLobbyModal] = useState(false)

  useEffect(() => {
    document.title = `${config.eventName} | Lobby`
  }, [])

  useEffect(() => {
    Amplitude.visit('Lobby')
  }, [currentUser.id])

  const toggleLobbyModal = () => {
    setShowLobbyModal(!showLobbyModal)
  }

  return (
    <>
      <StyledLobby>
        <PageWithBg bgImg={config.assets.lobby.landscape}>
          {config.lobbyEntries.map((entry) => {
            return <LobbyEntry key={entry.id} {...entry} currentUser={currentUser} />
          })}
          <div className='video-container'>
            <div style={{position:'relative'}}>
            <iframe src="https://player.vimeo.com/video/648318171?autoplay=1&muted=1&h=18405483a3" frameBorder="0" allow="autoplay; fullscreen; picture-in-picture" allowFullScreen style={{position:'absolute',top:'0',left:'0',width:'100%',height:'100%'}} title="pre v7 VIdeo Promo ADFIM"></iframe></div><script src="https://player.vimeo.com/api/player.js"></script>
          </div>
          <img id="game-stand" width="160px" src={GameStand} alt="game stand" onClick={toggleLobbyModal} />
          <div id="current-user">Logged in as {currentUser.email}</div>
        </PageWithBg>
        {showLobbyModal && <GameModal showModal={showLobbyModal} hideModal={toggleLobbyModal} currentUser={currentUser} />}
      </StyledLobby>
    </>
  )
}
